import React, { Component } from "react";
import {
  Row,
  Col,
  Container,
  Label,
  Button,
} from "reactstrap";

import { Link } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    //meta title
    document.title =
      "Forgot Password | Skote - React Admin & Dashboard Template";
    return (
      <React.Fragment>
        <Container fluid className="main-login-flow">
          <Row className="px-lg-0 px-md-5 px-2">
            <Col xl={4} lg={12} className="offset-xl-2 mt-1">
              <div className="logo-main">
                <span className="text-white login-flow-logo fs-2 fw-bold d-inline-block">
                  LOGO
                </span>
              </div>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  password: (this.state && this.state.email) || "",
                  cpassword: (this.state && this.state.cpassword) || "",
                }}
                validationSchema={Yup.object().shape({
                  password: Yup.string().required("Please Enter your Password"),
                  cpassword: Yup.string().required(
                    "Please confirm your password"
                  ),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched }) => (
                  <Form>
                    <h1 className="text-primary-light fw-bold pt-md-5 login-flow-h1">
                      New Password
                    </h1>
                    <p className="login-flow-p pt-2 pb-2">Enter your new password</p>
                    <div className="mt-2">
                      <Label
                        for="email"
                        className="form-label d-block pb-2 fw-bold login-flow-lable"
                      >
                        New Password
                      </Label>
                      <Field
                        name="password"
                        placeholder="New password"
                        type="password"
                        className={
                          "form-control py-1 py-md-3 fs-4" +
                          (errors.password && touched.password
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="mt-2">
                      <Label
                        for="cpassword"
                        className="form-label d-block pb-2 fw-bold login-flow-lable"
                      >
                        Confirm Password
                      </Label>
                      <Field
                        name="cpassword"
                        placeholder="************"
                        type="password"
                        className={
                          "form-control py-1 py-md-3 fs-4" +
                          (errors.cpassword && touched.cpassword
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <ErrorMessage
                        name="cpassword"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="mt-0 mt-md-5">
                        <Button
                          className="w-100 text-white fw-bold fs-3 login-flow-btn mt-2"
                          type="submit"
                        >
                          Save Password
                        </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
            <Col
              xl={6}
              lg={12}
              className="text-center text-xl-start align-self-center"
            >
              <img
                src="images/loginFlow-images/forgotPass.svg"
                alt="login"
                className="w-md-100"
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default NewPassword;
